<template>
  <div>
    <div class="full-width q-px-md text-grey-9 q-mt-md" id="itinerary-list">
      <div class="row items-center q-pb-xs justify-start full-width">
        <div class="text-uppercase text-weight-bold">itinerary by day</div>

        <div
          class="q-ml-auto text-secondary row items-end justify-center cursor-pointer q-pr-xs"
          @click="expandOrColapseAll(!validateAllExpanded)"
        >
          <div class="text-capitalize q-mr-xs">
            {{ validateAllExpanded ? "collapse all" : "expand all" }}
          </div>
          <q-icon
            :name="!validateAllExpanded ? 'expand_more' : 'expand_less'"
            color="secondary"
            size="16px"
          />
        </div>
      </div>
      <q-separator />
      <q-list class="list" separator>
        <q-expansion-item
          dense
          :class="['list-item', { 'bg-grey-1': index % 2 === 0 }]"
          expand-icon-class="list-item-icon text-secondary"
          default-opened
          v-model="expandControl[index]"
          @input="(val) => toggleRow(val, index)"
          v-for="(item, index) in sectionData.list"
          :key="index"
        >
          <template #header>
            <div class="row items-center justify-start full-width">
              <div
                class="bg-secondary text-uppercase text-white rounded-borders day"
              >
                Day {{ getDay(item) }}
              </div>

              <div
                class="text-secondary q-pl-sm text-weight-bold"
                v-if="item.date"
              >
                {{ getDate(item) }}
              </div>
            </div>
          </template>

          <template #default>
            <DItineraryListPorts :item="item" />
          </template>
        </q-expansion-item>
      </q-list>
    </div>
  </div>
</template>

<script>
import { debounce } from "quasar";
import DItineraryListPorts from "../../components/DItineraryListComponents/DItineraryListPorts.vue";
import mixin from "../../d-card-mixins";
import moment from "moment";

export default {
  name: "DItineraryList",
  mixins: [mixin],
  components: { DItineraryListPorts },
  props: {
    sectionData: {
      type: Object,
      required: true,
    },
    behavior: {
      type: String,
      default: "agent",
    },
    storePath: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      expandControl: {},
      weekDaysAbbreviations: [
        "Mon",
        "Tues",
        "Wed",
        "Thurs",
        "Fri",
        "Sat",
        "Sun",
      ],
      monthAbbreviations: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  computed: {
    validateAllExpanded: {
      get() {
        const values = [];
        for (const key in this.expandControl) {
          values.push(this.expandControl[key]);
        }

        return values.every((v) => !!v);
      },
    },
    expandControlConsumer: {
      get() {
        return this.$cardStore.get(this.storePath);
      },
    },
  },
  created() {
    this.emitState = debounce(this.emitState, 200);
  },
  mounted() {
    if (this.behavior === "consumer") {
      this.$watch("expandControlConsumer", (val) => {
        this.expandControl = JSON.parse(val).expandControlConsumer ?? {};
      });
    }

    setTimeout(() => {
      if (this.$route.query.agent === "true" || this.behavior === "agent") {
        this.expandOrColapseAll(true);
      }
    }, 300);
  },
  methods: {
    validateChangeState() {
      return (
        JSON.stringify({ expandControlConsumer: this.expandControl }) !==
        this.expandControlConsumer
      );
    },
    expandOrColapseAll(expand = true) {
      const temp = {};
      for (const [index] of this.sectionData.list.entries()) {
        temp[index] = expand;
      }

      this.expandControl = temp;
    },
    getDay(data) {
      return typeof data.day === "string"
        ? data.day.replace(/day|days/gi, "").trim()
        : data.day;
    },
    getDate(data) {
      const date = moment(data.date);
      return date.format("ddd, MMM DD");
    },
    getExcursions(data) {
      return data.excursions ?? [];
    },
    toggleRow(val, index) {
      this.expandControl[index] = val;
      this.expandControl = this.expandControl;
    },
    emitState() {
      this.$cardStore.set(
        this.storePath,
        JSON.stringify({ expandControlConsumer: this.expandControl })
      );
    },
  },
  watch: {
    expandControl: {
      deep: true,
      handler() {
        if (this.validateChangeState() && this.behavior === "consumer") {
          this.emitState();
        }
      },
    },
  },
};
</script>

<style lang="scss">
#itinerary-list {
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.2;

  .list {
    &-item {
      .q-expansion-item__container > .q-item--clickable {
        padding: 14px 4px 16px;
      }

      &-icon {
        padding: 0;

        .material-icons {
          font-size: 16px;
        }
      }

      .content {
        padding: 0 4px 12px;

        .excursions {
          .header,
          .body > div {
            border-bottom: 1px dashed rgba(0, 0, 0, 0.12);

            > div {
              font-size: 8px;

              &:first-child {
                font-size: 9px;
              }
            }
          }

          .body,
          .header {
            &-cell {
              width: 40px;

              &:first-child {
                width: auto;
              }
            }
          }

          .body-cell {
            line-height: 160%;
          }

          .header-cell {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }
    .day {
      padding: 2px 6px;
      font-size: 10px;
      font-weight: 800;
      line-height: 16px;
    }
  }
}
</style>
